export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_03-4bbc8ebd86a07f08b073f6fb78344f7e.jpg";